<template>
<div class="chapter">
<div class="inner_page">
<p class="chaptit"><b>Maps and Sidebars</b></p>
<p class="toc3"><b>Maps</b></p>
<p class="toc2"><a href="#/xhtml/cha03#map1">1.  The Western Front</a></p>
<p class="toc2"><a href="#/xhtml/cha03#map2">2.  The Eastern Front</a></p>
<p class="toc2"><a href="#/xhtml/cha03#map3">3.  Mesopotamia and Persia</a></p>
<p class="toc2"><span href="#/xhtml/cha04#map4" title="Link target outside of Sample">4.  Gallipoli</span></p>
<p class="toc2"><span href="#/xhtml/cha04#map5" title="Link target outside of Sample">5.  Egypt, Palestine, and Syria</span></p>
<p class="toc2"><span href="#/xhtml/cha08#map6" title="Link target outside of Sample">6.  The Western Front (Armistice)</span></p>
<p class="toc3"><b>Sidebars</b></p>
<p class="toc2"><a href="#/xhtml/cha03#box-1">Naval Strength at the Beginning of the War</a></p>
<p class="toc2"><a href="#/xhtml/cha03#box-2">Population and Military Strength at the Beginning of the War</a></p>
<p class="toc2"><a href="#/xhtml/cha03#box-3">Infantry Tactics</a></p>
<p class="toc2"><span href="#/xhtml/cha04#box-4" title="Link target outside of Sample">Trench Warfare</span></p>
<p class="toc2"><span href="#/xhtml/cha04#box-5" title="Link target outside of Sample">Poison Gas</span></p>
<p class="toc2"><span href="#/xhtml/cha04#box-6" title="Link target outside of Sample">Machine Guns</span></p>
<p class="toc2"><span href="#/xhtml/cha04#box-7" title="Link target outside of Sample">Propaganda</span></p>
<p class="toc2"><span href="#/xhtml/cha04#box-8" title="Link target outside of Sample">Airplanes</span></p>
<p class="toc2"><span href="#/xhtml/cha04#box-9" title="Link target outside of Sample">Artillery</span></p>
<p class="toc2"><span href="#/xhtml/cha05#box-10" title="Link target outside of Sample">Tanks</span></p>
<p class="toc2"><span href="#/xhtml/cha05#box-11" title="Link target outside of Sample">Naval Warfare</span></p>
<p class="toc2"><span href="#/xhtml/cha05#box-12" title="Link target outside of Sample">Communcations and Command Control</span></p>
<p class="toc2"><span href="#/xhtml/cha05#box-13" title="Link target outside of Sample">Air Aces</span></p>
<p class="toc2"><span href="#/xhtml/cha06#box-14" title="Link target outside of Sample">Submarines</span></p>
<p class="toc2"><span href="#/xhtml/cha06#box-15" title="Link target outside of Sample">Mutinies</span></p>
<p class="toc2"><span href="#/xhtml/cha06#box-16" title="Link target outside of Sample">Songs of War</span></p>
<p class="toc2"><span href="#/xhtml/cha07#box-17" title="Link target outside of Sample">Human Costs</span></p>
<p class="toc2"><span href="#/xhtml/cha08#box-18" title="Link target outside of Sample">The Literature of War</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// toc1.vue?74c0d3ec